import SymbolsPreview from '@/features/_shared/SymbolsPreview';
import type { Message } from '@/features/ai-chat/types/chat.types';
import { Spinner } from '@/shared/ui/feedback/Spinner';
import { ExpandMore as ExpandMoreIcon } from '@/shared/ui/icons';
import { Box } from '@/shared/ui/layout/Box';
import { ButtonBase } from '@/shared/ui/primitives/ButtonBase';

import { useSymbolsPreview } from './useSymbolsPreview';

const SymbolsPreviewSection = ({ msg, isVisible }: { msg: Message; isVisible: boolean }) => {
  const { gxCodes, trimmedGxCodes, results, isExpanded, toggleExpanded, hasMore } =
    useSymbolsPreview(msg);

  if (!isVisible || !gxCodes.length) return null;

  if (results.pending) {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Spinner
          centered={false}
          size={24}
        />
      </Box>
    );
  }

  return (
    <>
      <SymbolsPreview
        forChat
        enableQuery={false}
        items={results.data}
      />
      {hasMore && (
        <Box
          sx={{
            backgroundColor: trimmedGxCodes.length % 2 === 0 ? 'gx.tileDark' : 'gx.tileLight',
            px: '16px'
          }}
        >
          <ButtonBase
            sx={{ color: 'gx.highlight' }}
            onClick={toggleExpanded}
          >
            {isExpanded ? 'See less' : 'See more'}
            <ExpandMoreIcon sx={{ rotate: isExpanded ? '180deg' : '0deg', width: '14px' }} />
          </ButtonBase>
        </Box>
      )}
    </>
  );
};

export default SymbolsPreviewSection;
